"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const set_container_dimensions_1 = require("./set-container-dimensions");
const set_image_url_1 = require("./set-image-url");
const set_loading_image_1 = require("./set-loading-image");
const set_warnings_1 = require("./set-warnings");
const set_image_dimensions_1 = require("./set-image-dimensions");
const set_advanced_accordion_opened_1 = require("./set-advanced-accordion-opened");
const set_aspect_ratio_locked_1 = require("./set-aspect-ratio-locked");
const set_image_alt_text_1 = require("./set-image-alt-text");
const set_tab_1 = require("./set-tab");
const set_image_visibility_state_1 = require("./set-image-visibility-state");
const set_initial_style_1 = require("./set-initial-style");
function setters() {
    return {
        setContainerDimensions: set_container_dimensions_1.setContainerDimensions(),
        setImageUrl: set_image_url_1.setImageUrl(),
        setLoadingImage: set_loading_image_1.setLoadingImage(),
        setWarnings: set_warnings_1.setWarnings(),
        setImageDimensions: set_image_dimensions_1.setImageDimensions(),
        setAdvancedAccordionOpened: set_advanced_accordion_opened_1.setAdvancedAccordionOpened(),
        setAspectRatioLocked: set_aspect_ratio_locked_1.setAspectRatioLocked(),
        setImageAltText: set_image_alt_text_1.setImageAltText(),
        setTab: set_tab_1.setTab(),
        setImageVisibilityState: set_image_visibility_state_1.setImageVisibilityState(),
        setInitialStyle: set_initial_style_1.setInitialStyle(),
    };
}
exports.setters = setters;
//# sourceMappingURL=setters.js.map